import React from 'react';
import * as Yup from 'yup';

import { ApplicationFlow } from '../components';
import { documentTypes } from '../data';


const Description = () => (
  <React.Fragment>
    <p>
      A partnership is a legal form of business operation between two or more individuals who share management and profits. The federal government recognizes several types of partnerships. The two most common are general and limited partnerships.
    </p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Partnership Information',
    fields: new Map([
      ['orgName', {
        label: 'Partnership Name',
        title: 'Please enter the name of the partnership',
        'data-help-title': 'Partnership Name',
        'data-help-text': 'Please enter the name of the partnership.',
        validation: Yup.string().required('Please enter the name of the partnership'),
      }],
      ['dba', {
        label: 'Trade Name / DBA',
        'data-help-text': 'Please enter the trade name of the partnership.',
      }],
    ]),
  },
  {
    legend: 'Primary Partner Information',
    fields: new Map([
      ['firstName', {
        'data-help-title': 'General Partner',
        'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.',
      }],
      ['middleName', {
        'data-help-title': 'General Partner',
        'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.',
      }],
      ['lastName', {
        'data-help-title': 'General Partner',
        'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.',
      }],
      ['socialSecurity', {
        'data-help-title': 'General Partner',
        'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.',
      }],
      ['verifySocialSecurity', {
        'data-help-title': 'General Partner',
        'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.',
      }],
      ['title', {
        label: "Partner's Title",
        placeholder: 'Mangaing Member',
        'data-help-title': 'Mangaing Member',
        'data-help-text': 'A Mangaing Member is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.',
      }],
      ['suffix', {
        initial: 'DDS',
      }],
    ]),
  },
  {
    legend: 'Business Address (No PO Boxes)',
    fields: new Map([
      ['businessAddress'],
      ['businessCity'],
      ['businessState'],
      ['businessZip'],
      ['businessCounty'],
      ['mailingAddressDiff'],
    ]),
  },
  {
    legend: 'Business Information',
    fields: new Map([
      ['businessApplyReason'],
      ['businessActivity'],
      ['businessServices'],
      ['businessHireEmployees'],
    ]),
  },
  {
    legend: 'Business Dates',
    fields: new Map([
      ['businessDateStart'],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail'],
      ['customerContactEmailVerify',{
        label: 'Verify Contact E-mail'
      }],
    ]),
  },
];


const PartnershipApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Partnership Application"
    documentType={documentTypes.PARTNERSHIP}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default PartnershipApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/partnership-application.js